import { createApp } from 'vue'

import './styles/global.css';

import store from './stores';
import i18n from './i18n';
import App from './app.vue'
import router from './router'
import lozad from './utils/lozad';

const observer = lozad('.lozad', {
  enableAutoReload: true,
});
observer.observe();

const app = createApp(App)

app.use(i18n);
app.use(store)
app.use(router)

app.mount('#app')
